import React, { createContext, useContext, useEffect, useState } from 'react';

const LocationContext = createContext();

export const useLocationContext = () => useContext(LocationContext);

export const LocationProvider = ({ children }) => {
  const [isLocationValid, setLocationValid] = useState(() => {
    const isLocationValid = localStorage.getItem('isLocationValid');
    if (isLocationValid) {
      return isLocationValid === 'true';
    } else {
      
      return false;
    }
  });
  const [hasVisitedPayment, setHasVisitedPayment] = useState(localStorage.getItem('hasVisitedPayment') === 'true');

  useEffect(() => {
    // 同步本地存储和上下文状态
    localStorage.setItem('hasVisitedPayment', hasVisitedPayment.toString());
  }, [hasVisitedPayment]);

  useEffect(() => {
    // 同步本地存储和上下文状态
  
    localStorage.setItem('isLocationValid', isLocationValid.toString());
  }, [isLocationValid]);
  useEffect(() => {
    const isLocationValid = localStorage.getItem('isLocationValid');
    if (isLocationValid) {
      setLocationValid(isLocationValid === 'true'); 
    } else {
      
      setLocationValid(false);
    }
  }, []);

  return (
    <LocationContext.Provider value={{ isLocationValid, setLocationValid, hasVisitedPayment, setHasVisitedPayment }}>
      {children}
    </LocationContext.Provider>
  );
};
